<template>
  <v-card>
    <v-card-title>
      {{$t('LoginPage.PasswordForm.header')}}
    </v-card-title>
    <v-card-text>
      <PasswordForm v-model="password" @validation="state => isValid = state" @enter="() => isValid && submitPassword()"/>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn 
        text
        color="grey" 
        @click="$emit('cancel')" 
      >
        {{$t('Global.Action.cancel')}}
      </v-btn>
      <v-btn  
        color="primary" 
        :loading="loading" 
        @click="submitPassword" 
        :disabled="!isValid"
      >
        {{$t('Global.Action.confirm')}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ResetPasswordService } from '@portal/api'
import PasswordForm from '@/components/Utils/PasswordForm'
export default {
  name: 'TheResetPasswordForm',
  components: { PasswordForm },
  data: () => ({
    password: '',
    loading: false,
    isValid: false
  }),
  methods: {
    async submitPassword () {
      this.loading = true
      try {
        await ResetPasswordService.updatePassword(this.$route.query.token, this.password)
        this.$emit('passwordUpdated')
      } catch (error) {
        this.loading = false
        this.$emit('error', this.$t('LoginPage.Error.updatePassword'))
        throw error
      }
    }
  }
}
</script>